import ConversationListCard from '@app/components/presentational/MessagingResponsive/ConversationListCard';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Divider, IconButton, Icons, useTheme } from '@ublend-npm/aulaui-core';
import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectorsResponsive,
  operationsResponsive,
} from '@app/store/conversations';
import InfiniteTable from '@app/components/presentational/common/InfiniteTable';
import { mutedConversations } from '@core/notifications/selectors';

const AllConversationView = (props) => {
  const {
    handleConversationClick,
    isAllConversationsDialogOpen,
    setIsAllConversationsDialogOpen,
  } = props;
  const { palette } = useTheme();
  const dispatch = useDispatch();

  const conversations = useSelector(selectorsResponsive.paginatedConversations);
  const loadingMoreConversations = useSelector(
    selectorsResponsive.loadingMoreConversations
  );
  const mutedConversation = useSelector(mutedConversations);

  const totalCount = useSelector((state) =>
    selectorsResponsive.totalCount(state)
  );

  return (
    <Dialog
      open={isAllConversationsDialogOpen}
      onClose={() => setIsAllConversationsDialogOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="all-conversations-dialog-title"
      aria-describedby="all-conversations-dialog-description"
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: palette.background.paper,
          color: palette.text.primary,
        },
      }}
    >
      <DialogTitle id="all-conversations-dialog-title" sx={{ padding: 2 }}>
        All Conversations
        <IconButton
          onClick={() => setIsAllConversationsDialogOpen(false)}
          aria-label="Close"
          size="small"
          sx={{
            color: palette.text.secondary,
            '&:hover': { color: palette.text.primary },
            float: 'right',
          }}
        >
          <Icons.Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 2, paddingTop: 0 }}>
        <Box sx={{ height: 'calc(100vh - 200px)' }}>
          <InfiniteTable
            items={conversations}
            keyExtractor={(conversation) => conversation.id}
            renderItem={(conversation: any) => (
              <Box>
                <ConversationListCard
                  conversation={conversation}
                  conversationMuted={!!mutedConversation?.[conversation.id]}
                  selected={false}
                  onClick={() =>
                    handleConversationClick(
                      conversation.id,
                      conversation?.closed
                    )
                  }
                />
                <Divider sx={{ marginBlock: 1 }} />
              </Box>
            )}
            hasNext={totalCount > conversations.length}
            loadNext={() => {
              const nextPage = Math.floor(conversations.length / 20) + 1;
              if (operationsResponsive?.loadMoreConversations) {
                dispatch(
                  operationsResponsive.loadMoreConversations(false, nextPage)
                );
              }
            }}
            loading={loadingMoreConversations}
            renderEmptyList={() => null}
            renderHeader={() => null}
            renderFooter={() => null}
            viewStyle={{ width: '100%' }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AllConversationView;
